import { LegalLayout, LegalSection } from "./LegalLayout";

export default function CommunityGuidelinesPage() {
  return (
    <LegalLayout title="Community guidelines" updated="6 July 2026">
      <LegalSection heading="Why we have these">
        <p>
          Atlas's feed is for celebrating what you've explored — posts, comments and awards
          between explorers. Keep it a good place to hang out.
        </p>
      </LegalSection>

      <LegalSection heading="Do">
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Share your own summits, trails and achievements.</li>
          <li>Encourage other explorers — awards exist to celebrate someone else's post.</li>
          <li>Keep comments on-topic and constructive.</li>
          <li>Report anything that breaks these guidelines.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Don't">
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Harass, threaten or demean other explorers.</li>
          <li>Post spam, scams or unrelated advertising.</li>
          <li>Impersonate someone else or misrepresent an activity as your own.</li>
          <li>Post anything illegal, hateful, or that endangers someone's safety.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Reporting">
        <p>
          Every post has a report option. Reports go to the Atlas team for review; we can remove
          content and, for repeated or serious breaches, suspend accounts. Reporting doesn't
          notify the person you're reporting.
        </p>
      </LegalSection>

      <LegalSection heading="Enforcement">
        <p>
          We may remove content or restrict accounts that breach these guidelines, at our
          discretion, without prior notice for serious cases. This is separate from — and in
          addition to — the terms of service.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Questions, or something urgent we should know about:{" "}
          <a href="mailto:hello@goatlas.co.uk" style={{ color: "var(--text-accent)" }}>hello@goatlas.co.uk</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
